import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject } from 'rxjs/Subject';

@Injectable()

export class LoaderService {

    loading:boolean;
    loadingChange : Subject<boolean> = new Subject<boolean>();

    constructor(){
        // console.log("construct of loader service");
        this.loadingChange.subscribe((value)=>{
            // console.log("changing the loading property to ", value);
            this.loading = value;
        })
    }

    changeLoadingVisibility(value){
        // console.log("toggle loader display");
        this.loadingChange.next(value);
    }






}



// WEBPACK FOOTER //
// ./src/app/shared/loader.service.ts